import i18next from 'i18next'
import { getConstantsArray } from 'src/lib/constants'

const { t } = i18next
const { t_caps } = getConstantsArray()

// ADD caps HERE ONLY IF IT'S BOUNDED TO SYSTEM MODULE
export const requiredModules = {
  // MANAGEMENT
}

const getCapsGroups = () => [
  {
    name: t('components.access_levels.settings', 'Impostazioni'),
    start: t_caps.findIndex(c => c === 'show_users'),
    stop: t_caps.findIndex(c => c === 'manage_dealers'),
  },
  {
    name: t('components.access_levels.appointments', 'Visite'),
    start: t_caps.findIndex(c => c === 'show_appointments'),
    stop: t_caps.findIndex(c => c === 'manage_calendar'),
  },
  {
    name: t('components.access_levels.Home', 'Home'),
    start: t_caps.findIndex(c => c === 'show_documents'),
    stop: t_caps.findIndex(c => c === 'show_map'),
  },
]

export default getCapsGroups
